import {observer} from "mobx-react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import React from "react";
import SelectSearchMain from "@dropDesk/presentation/components/inputs/select_search_main";
import {TicketConfig} from "@dropDesk/domain/entities/ticket/ticket_config";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {Tooltip} from "antd";

const InputStatusSearch = observer(
    ({
         setFilterStatus,
         filterStatus,
         loading,
         hideLabel,
         size
     }: {
        setFilterStatus: (filter: TicketConfig | null, withList?: boolean) => void,
        filterStatus: TicketConfig | null,
        loading: boolean,
        hideLabel?: boolean,
        size?: number
    }) => {

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;

        return (
            <Tooltip title={hideLabel ? 'Filtrar por status' : undefined}>
                <div style={{display: "flex", flex: 1}}>
                    <SelectSearchMain<string>
                        disabled={loading}
                        size={size ?? 40}
                        useRemoveFilter={!!filterStatus}
                        label={hideLabel ? undefined : 'Filtrar por status'}
                        placeHolder={"Pesquise por status"}
                        options={appController.isUserClient ? appController.ticketStatusContactConfigs.map((item) => item.toOptionType()) : appController.ticketStatusConfigs.map((item) => item.toOptionType())}
                        removeSort={true}
                        onChange={(value: string | undefined) => {
                            const status = appController.getStatusById(value);
                            setFilterStatus(status ?? null);
                        }}
                        value={filterStatus ? TicketConfig.translateStatusToHuman(filterStatus.description) : null}
                        iconLeftName={ICONS_DROPDESK.status}
                        borderColor={filterStatus ? colors.accent : colors.border}
                    />
                </div>
            </Tooltip>
        )
    })
export default InputStatusSearch;
